/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BreakdownBeneficiaryDto } from './BreakdownBeneficiaryDto';
import {
    BreakdownBeneficiaryDtoFromJSON,
    BreakdownBeneficiaryDtoFromJSONTyped,
    BreakdownBeneficiaryDtoToJSON,
    BreakdownBeneficiaryDtoToJSONTyped,
} from './BreakdownBeneficiaryDto';
import type { BreakdownFluxDetailDto } from './BreakdownFluxDetailDto';
import {
    BreakdownFluxDetailDtoFromJSON,
    BreakdownFluxDetailDtoFromJSONTyped,
    BreakdownFluxDetailDtoToJSON,
    BreakdownFluxDetailDtoToJSONTyped,
} from './BreakdownFluxDetailDto';

/**
 * Total amounts grouped by beneficiary with flow detail
 * @export
 * @interface BreakdownTotalByBeneficiaryDto
 */
export interface BreakdownTotalByBeneficiaryDto {
    /**
     * 
     * @type {BreakdownBeneficiaryDto}
     * @memberof BreakdownTotalByBeneficiaryDto
     */
    beneficiary: BreakdownBeneficiaryDto;
    /**
     * 
     * @type {string}
     * @memberof BreakdownTotalByBeneficiaryDto
     */
    beneficiaryType: string;
    /**
     * 
     * @type {number}
     * @memberof BreakdownTotalByBeneficiaryDto
     */
    totalAmount: number;
    /**
     * Beneficiary share of total amount as a percentage (computed by backend)
     * @type {number}
     * @memberof BreakdownTotalByBeneficiaryDto
     */
    shareOfTotal: number;
    /**
     * 
     * @type {Array<BreakdownFluxDetailDto>}
     * @memberof BreakdownTotalByBeneficiaryDto
     */
    flowDetails: Array<BreakdownFluxDetailDto>;
}

/**
 * Check if a given object implements the BreakdownTotalByBeneficiaryDto interface.
 */
export function instanceOfBreakdownTotalByBeneficiaryDto(value: object): value is BreakdownTotalByBeneficiaryDto {
    if (!('beneficiary' in value) || value['beneficiary'] === undefined) return false;
    if (!('beneficiaryType' in value) || value['beneficiaryType'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('shareOfTotal' in value) || value['shareOfTotal'] === undefined) return false;
    if (!('flowDetails' in value) || value['flowDetails'] === undefined) return false;
    return true;
}

export function BreakdownTotalByBeneficiaryDtoFromJSON(json: any): BreakdownTotalByBeneficiaryDto {
    return BreakdownTotalByBeneficiaryDtoFromJSONTyped(json, false);
}

export function BreakdownTotalByBeneficiaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownTotalByBeneficiaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'beneficiary': BreakdownBeneficiaryDtoFromJSON(json['beneficiary']),
        'beneficiaryType': json['beneficiaryType'],
        'totalAmount': json['totalAmount'],
        'shareOfTotal': json['shareOfTotal'],
        'flowDetails': ((json['flowDetails'] as Array<any>).map(BreakdownFluxDetailDtoFromJSON)),
    };
}

export function BreakdownTotalByBeneficiaryDtoToJSON(json: any): BreakdownTotalByBeneficiaryDto {
    return BreakdownTotalByBeneficiaryDtoToJSONTyped(json, false);
}

export function BreakdownTotalByBeneficiaryDtoToJSONTyped(value?: BreakdownTotalByBeneficiaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'beneficiary': BreakdownBeneficiaryDtoToJSON(value['beneficiary']),
        'beneficiaryType': value['beneficiaryType'],
        'totalAmount': value['totalAmount'],
        'shareOfTotal': value['shareOfTotal'],
        'flowDetails': ((value['flowDetails'] as Array<any>).map(BreakdownFluxDetailDtoToJSON)),
    };
}

